import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { LoadingController } from 'ionic-angular';

import { MysqlService } from '../../services/mysql.service';
import "rxjs/add/operator/map";

@Injectable()
export class ImcpaAppProvider {
   
  public access: any = {};

  public isLoggedIn: boolean = false;

  public appVersion: any = '(V.20.1.01a)';

  public temples = [{
    name: "Bhaktivedanta Manor",
    image: "https://s3.amazonaws.com/worldpackersproduction/volunteer_positions/photos/000/007/216/main/5d01dd843b06fab219ad217e85472174.jpg"
    }, 
    {name: "New Vrindavan",
    image: "https://iskconnews.org/media/img_versions/2014/03-Mar/new%20vrindaban%20gas_slideshow.jpg"
    }];
  

  public goshalas = [
    {
    name: "New Govardhan Farm",
    website: "https://www.krishnafarm.net/cow-protection/",
    continent: "Oceania",
    country: "Australia",
    cows: "42",
    bulls: "32",
    image: "https://www.krishnafarm.net/wp-content/uploads/2015/02/IMG_4746-630x420.jpg",
    ownerName: "Ajita Das",
    contact: "(+61) 419645 305",
    email: "ajitacozzi@gmail.com",
    lat: "-28.356138",
		lng: "153.319070",
		// label: 'New Govardhan Farm'
  },
    {
    name: "New Gokul Farm",
    website: "http://bhaktivedantamanor.co.uk/newgokul/",
    continent: "Europe",
    country: "United Kingdom",
    cows: "39",
    bulls: "43",
    image: "https://api.ning.com/files/VG*5ompgnqoL-pbthtVpXJ5OUwDRkSL3riHV5paPepzlRbFMWOtxdfRbXZInEcc5ntahk10TrZ*nyjEmMDowzJSaK6icDIYw/gshmain.jpg",
    ownerName: "Bhakta Pradeep",
    contact: "+12 (345)234-2345",
    email: "pradeep@krishnatemple.com",
    lat: "51.665168", 
		lng: "-0.338344",
  }, 
  {
    name: "Gitanagari Farm",
    website: "https://gnecofarm.org/",
    continent: "North America",
    country: "United States",
    cows: "70",
    bulls: "10",
    image: "https://iskconnews.org/media/img_versions/2014/08-Aug/GitaN1_slideshow.jpg",
    ownerName: "Keshav Madhav Das",
    contact: "+1 (702)575-7067",
    lat: 40.494236,
		lng: -77.464173,}];

  public resources = [{
    title: "ISKCON Cow Protection",
    subTitle: "Minimum Cow Protection Standards",
    language: "English",
    author: "",
    bookLink: "https://dev-x.co.za/MayapurIT/Goshala/MinimumCowProtectionStandards.pdf",
    coverImage: "https://dev-x.co.za/MayapurIT/Goshala/MinimumCowProtectionStandards.jpg"
    }
    // {    title: "ISKCON Cow Protection",
    // subTitle: "Minimum Cow Protection Standards",
    // language: "Russian",
    // bookLink: "",
    // coverImage: "https://s3.amazonaws.com/worldpackersproduction/volunteer_positions/photos/000/007/216/main/5d01dd843b06fab219ad217e85472174.jpg"
    // }
    ];

  public vets = [{
    name: "Anurag Das",
    image: "https://pbs.twimg.com/profile_images/3161198936/d0df30b2b4330c91dd24ea6ee147f3c8.jpeg",
    phone: "+908976543421"
  }, 
  {
    name: "Srinivasan Chettiyar",
    image: "https://content3.jdmagicbox.com/comp/salem/h9/0427px427.x427.150804182947.y8h9/catalogue/dr-sivabalan-neomed-hospital-hastampatti-salem-orthopaedic-doctors-sm96t.jpg",
    phone: "+987896543212"}];

public medicalStocks = [{
    number: "2",
    name: "Aluspray",
    category: "Medicines",
    expiry: "12/3/19",
    purchase: "5/12/18",
    qty: "3",
    reOrder: "5"
  }, 
  {
    number: "3",
    name: "Labels",
    category: "Tags",
    expiry: "12/3/20",
    purchase: "5/11/18",
    qty: "50",
    reOrder: "10"
  }, 
    {
    number: "5",
    name: "Cotton Rolls",
    category: "Other",
    expiry: "12/3/20",
    purchase: "5/11/18",
    qty: "10",
    reOrder: "5"
  }, 
      {
    number: "6",
    name: "Dettol",
    category: "Antiseptic",
    expiry: "12/11/18",
    purchase: "5/3/18",
    qty: "10",
    reOrder: "5"
  }, 
  {
    number: "4",
    name: "Viral respiratory vaccine",
    category: "Needles",
    expiry: "12/2/19",
    purchase: "5/12/18",
    qty: "5",
    reOrder: "6"}];


public feeds = [{
    name: "Hay Barrels",
    mfrDate: "10/11/18",
    expiryDate: "12/3/19",
    date: "5/12/18",
    qty: "3",
    reOrder: "5"
  }, 
  {
    name: "Green Grass Bunch",
    mfrDate: "10/01/19",
    expiryDate: "30/01/19",
    date: "15/01/19",
    qty: "50",
    reOrder: "10"
  }, 
    {
    name: "Grain Mixture (5 Kg Bag)",
    mfrDate: "20/11/18",
    expiryDate: "12/3/20",
    date: "5/12/18",
    qty: "10",
    reOrder: "5"
  }, 
      {
    name: "Jaggery (1 Kg Bag)",
    mfrDate: "12/02/18",
    expiryDate: "12/11/18",
    date: "5/3/18",
    qty: "10",
    reOrder: "5"
  }, 
  {
    name: "Barley (1 Kg Bag)",
    mfrDate: "10/09/18",
    expiryDate: "12/2/19",
    purchase: "5/12/18",
    qty: "5",
    reOrder: "6"}];

public tasks = [{
    category: "Cleaning",
    area: "Barn",
    dueDate: "26/1/19",
    frequency: "Daily",
    status: "New"
  }, 
  {
    category: "Repair",
    area: "Fence",
    dueDate: "31/1/19",
    frequency: "Adhoc",
    status: "In Progress",
  }, 
    {
    category: "Mow",
    area: "Grazing Yard",
    dueDate: "18/1/19",
    frequency: "Monthly",
    status: "Pending",
  }, 
      {
    category: "Weedling",
    area: "Barn",
    dueDate: "18/1/19",
    frequency: "Weekly",
    status: "Done",
  }];

public assets = [{
    name: "Tractor",
    category: "Vehicle",
    purchaseDate: "26/1/16",
    reviewDate: "23/01/19",
    status: "Purchased",
    qty: "2",
    condition: "Medium"
  }, 
  {
    name: "Shovel",
    category: "Tools",
    purchaseDate: "12/08/18",
    reviewDate: "1/01/19",
    status: "Purchased",
    qty: "5",
    condition: "Medium"  }, 
    {
    name: "Sickle",
    category: "Tools",
    purchaseDate: "8/10/18",
    reviewDate: "23/01/19",
    status: "Purchased",
    qty: "2",
    condition: "Poor" }, 
      {
    name: "Rake",
    category: "Tools",
    purchaseDate: "4/2/19",
    reviewDate: "",
    status: "Pending Purchase",
    qty: "2",
    condition: ""
  }];

public finances = [{
    description: "Cotton Rolls",
    category: "Medical",
    qauntity: "2",
    date: "26/12/18",
    type: "Expenditure",
    amount: "$6.00"
  }, 
  {
    description: "Grain Mixture",
    category: "Cattle Food",
    qauntity: "50lbs",
    date: "23/12/18",
    type: "Expenditure",
    amount: "$100.00"  }, 
    {
    description: "Fence Repair",
    category: "Donation",
    qauntity: "",
    date: "1/01/19",
    type: "Income",
    amount: "$500.00" }];

public storeItems = [{
    product: "Milk (1 Ltr)",
    category: "Dairy Products",
    qty: "100",
    mfrDate: "20/01/19",
    expiryDate: "30/01/19",
    price: "$4.00"
  }, 
  {
    product: "Milk (5 Ltr)",
    category: "Dairy Products",
    qty: "50",
    mfrDate: "25/01/19",
    expiryDate: "2/02/19",
    price: "$18.00"  }, 
    {
    product: "Ghee (1 Kg)",
    category: "Dairy Products",
    qty: "50",
    mfrDate: "10/12/18",
    expiryDate: "30/02/19",
    price: "$20.00" },
  {
    product: "Incense (1 Kg)",
    category: "Herbal Products",
    qty: "200",
    mfrDate: "12/11/18",
    expiryDate: "13/10/19",
    price: "$10.00" }];

public fundings = [{
    donor: "Sakshi Gopal Das",
    for: "Tractor",
    date: "26/12/18",
    payment: "Debit Card",
    amount: "$50,000.00"
  }, 
  {
    donor: "Pranab Chaterjee",
    for: "Shovels",
    date: "12/01/19",
    payment: "Cash",
    amount: "$50.00"  }, 
    {
    donor: "Arvind Sarout",
    for: "Fence Repair",
    date: "10/01/18",
    payment: "Credit Card",
    amount: "$500.00" }];

  public cows = [
    {
    name: "Chandramukhi",
    image: "https://dev-x.co.za/MayapurIT/Goshala/Australia/chandramukhi.jpg",
    gender: "Cow",
    breed: "Jersey",
    birthDate: "12/12/2011",
    color: "Brown & White"

  },
      {
    name: "Adi",
    image: "https://dev-x.co.za/MayapurIT/Goshala/Australia/adi.jpg",
    gender: "Bull",
    breed: "Jersey",
    birthDate: "12/12/2011",
    color: "Brown"

  },
        {
    name: "Govardhan",
    image: "https://dev-x.co.za/MayapurIT/Goshala/Australia/Govardhan.jpg",
    gender: "Bull",
    breed: "Jersey",
    birthDate: "12/12/2011",
    color: "Brown"

  },
  {
    name: "Syamagauri",
    image: "https://media.mnn.com/assets/images/2017/01/cow-in-pasture.jpg.838x0_q80.jpg",
    gender: "Cow",
    breed: "Jersey",
    birthDate: "12/12/2011",
    color: "Black & White"

  }, 
  {
    name: "Bhavani",
    image: "https://parade.com/wp-content/uploads/2018/01/cute-cow-FTR.jpg",
    gender: "Cow",
    breed: "Jersey",
    birthDate: "12/12/11",
    color: "Brown"}];

  public medicals = [{
    vetName: "Gaurahari Das",
    date: "13/09/18",
    category : "Infection",
    report: "infection on feet."
  }, 
  {
    vetName: "Mukund Das",
    date: "18/09/18",
    category : "Infection",
    report: "Followup for the infection on feet."}];

  public members = [{
    name: "Gaurahari Das",
    image: "https://s3.amazonaws.com/aphs.worldnomads.com/francesanddavid/10105/027.jpg",
    type: "Ambassador"
  }, 
  {
    name: "David Cameroon",
    image: "https://lh3.googleusercontent.com/-zAqi7uq4s1k/V18Wl4OhFaI/AAAAAAAAb5c/-9aDHwhY54M/s0/2016-06-13_22-24-50.jpg",
    type: "Donor"}];

  public loading;
  public myreturnvalue;

  public key: {};
 
  constructor(public http: Http, public dbService: MysqlService, public loadingCtrl: LoadingController) {
    console.log('Hello myApp Provider');
    
  }

  async presentLoading() {
    this.loading = await this.loadingCtrl.create({
      content: 'Loading Data, please wait..',
    });
    return await this.loading.present();  
  }


  getGoshalas(){
    return this.goshalas;
  }

  addGoshala(goshala){
    this.goshalas.push(goshala);
  }

  getTemples(){
    return this.temples;
  }

  addTemple(temple){
    this.temples.push(temple);
  }

 getResources(){
    return this.resources;
  }

  addResource(resource){
    this.resources.push(resource);
  }

 getMedicalStocks(){
    return this.medicalStocks;
  }

  addMedicalStock(medicalStock){
    this.medicalStocks.push(medicalStock);
  }

getFeeds(){
    return this.feeds;
  }

  addFeed(feed){
    this.feeds.push(feed);
  }

 getTasks(){
    return this.tasks;
  }

  addTask(task){
    this.tasks.push(task);
  }

 getAssets(){
    return this.assets;
  }

  addAsset(asset){
    this.assets.push(asset);
  }

 getFinances(){
    return this.finances;
  }

  addFinance(finance){
    this.finances.push(finance);
  }

 getFundings(){
    return this.fundings;
  }

  addFunding(funding){
    this.fundings.push(funding);
  }

 getStoreItems(){
    return this.storeItems;
  }

  addStoreItem(storeItem){
    this.storeItems.push(storeItem);
  }

  // getCows(){
  //   // console.log("Goshala id is: " + goshalaid);
  //   this.http.post("https://www.dev-x.co.za/MayapurIT/Goshala/cowdb.php?key=get&mysql=select * from cows")
  //   .map(res => res.json())
  //   .subscribe(res => {
  //     var cows = res.data; 
  //     return cows;
  //     console.log("Jason data: " + res.data);
  //     console.log("Cow Array : " + this.cows);
  //    }, (err) => {
  //      alert("Failed to Load Json data" + err)
  //    });
  // }

  addCow(cow){
    this.cows.push(cow);
  }

  getVets(){
    return this.vets;
  }

  addVet(vet){
    this.vets.push(vet);
  }

  getMembers(){
    return this.members;
  }

  addMember(member){
    this.members.push(member);
  }

  getMedicals(){
    return this.medicals;
  }

  addMedical(medical){
    this.medicals.push(medical);
  }


}



// WEBPACK FOOTER //
// ./src/providers/imcpaApp/imcpaApp.ts